import { makeStyles } from "@material-ui/core/styles";

const useStyleFooter = makeStyles((theme) => ({
  appBar: {
    //top: 'auto',
    //bottom: 0,
    minHeight: "128px",
    //position: 'relative',
    marginTop: "auto",
    backgroundColor: theme.palette.secondary.main,
  },
  appBar2: {
    //top: 'auto',
    //bottom: 0,
    minHeight: "48px",
    //position: 'relative',
    marginTop: "auto",
    backgroundColor: theme.palette.secondary.dark,
  },
  footer: {
    //marginTop: '1vh',
    display: "flex",
    justifyContent: "left",
    color: "#fff",
  },
  footerAlign: {
    justifyContent: "right",
  },
  cropper: {
    width: "352px",
    height: "128px",
    overflow: "hidden",
  },
  cropperImg: {
    transform: "rotate(-19deg)",
  },
}));

export default useStyleFooter;
